import Home from "./pages/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./App.scss"
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import Terms from "./pages/Terms";
import Policy from "./pages/Policy";
import ScrollToTop from "./ScrollTop";

function App() {
  return (
    <>
      <BrowserRouter basename="/">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/terms-conditions" element={<Terms />} />
          <Route path="/privacy-policy" element={<Policy />} />
        </Routes>
        <Toaster richColors={true} position="top-right" />
      </BrowserRouter>
    </>
  );
}

export default App;
